import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SplitBill, SplitBillCreate, SplitBillFilter } from '../data/splitBill';

export function createSplitBillService(client: AxiosInstance) {
  return createCrudService<SplitBill, SplitBillCreate, SplitBillFilter>(
    client,
    '/restaurant/SplitBill',
    'id',
  );
}

export type SplitBillService = CrudService<SplitBill, SplitBillCreate, SplitBillFilter>;
